module.exports = __webpack_public_path__ + "img/reviews-author-16.2908591.jpg";